"use client";

import { LoadingScreen } from "@/components/LoadingScreen";

export default function Loading() {
  return (
    <LoadingScreen 
      message="Accessing Archive" 
      submessage="Retrieving curated intelligence and establishing terminal downlink" 
    />
  );
}
